import { render, staticRenderFns } from "./SimplePayRadioInput.vue?vue&type=template&id=541f830a&scoped=true&"
import script from "./SimplePayRadioInput.vue?vue&type=script&lang=js&"
export * from "./SimplePayRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f830a",
  null
  
)

export default component.exports